import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Analytics from '@/analytics';
import { setShowInsertModalState } from '@/actions';
import { setLoginRequiredModalOpen, setSaveProjectModalOpen } from '@/store/actions/cmme';
import { Button, InsertIcon, DownloadIcon } from '@/components';
import { CTAPanelStyled } from './styles';

const CTAPanel = () => {
  const pages = useSelector((state) => state.core.pages);
  const isShowInsertModal = useSelector((state) => state.core.isShowInsertModal);
  const sectionsSelection = useSelector((state) => state.core.sectionsSelection);
  const shieldsSelection = useSelector((state) => state.core.shieldsSelection);
  const webComponentConfing = useSelector((state) => state.cmmeReducer.config);
  const dispatch = useDispatch();
  const hasPages = Object.keys(pages).length > 0;
  const areShieldsSelected = !!Object.keys(shieldsSelection).length;
  const areSectionsSelected = !!Object.keys(sectionsSelection).length;
  const isInsertButtonVisible = areShieldsSelected || areSectionsSelected;
  const isLoggedIn = !!webComponentConfing.authToken;
  const isAddToCartDisabled = !isLoggedIn;

  const handleInsertClick = () => {
    dispatch(setShowInsertModalState(true));
  };

  const handleAddToCartClick = () => {
    if (isAddToCartDisabled) {
      dispatch(setLoginRequiredModalOpen(true));
    } else {
      dispatch(setSaveProjectModalOpen(true));
    }

    Analytics.saveLayerOpen();
  };

  if (!hasPages || isShowInsertModal) {
    return null;
  }
  return (
    <CTAPanelStyled $isInsertButtonVisible={isInsertButtonVisible}>
      {isInsertButtonVisible && (
        <Button variant="primary" onClick={handleInsertClick}>
          <InsertIcon />
          <FormattedMessage id="cmme.insert" defaultMessage="Insert" />
        </Button>
      )}
      <Box sx={{ position: 'relative', display: 'grid' }}>
        <Button variant="secondary" onClick={handleAddToCartClick}>
          <Box sx={{ display: 'flex', mr: '10px' }}><DownloadIcon width={35} height={35} /></Box>
          <span><FormattedMessage id="app.footer.button.save" defaultMessage="Save" /></span>
        </Button>
      </Box>
    </CTAPanelStyled>
  );
};

export default CTAPanel;
